export const STATUSES = [
  { value: "published", label: "Опубликован" },
  { value: "review", label: "На ревью" },
  { value: "re_review", label: "На ревью повторно" },
  { value: "rejected", label: "Отклонено" },
];
